import React, { useState, useRef } from "react";
import Select from "shared/components/Input/Select";
import { Container, Row } from "reactstrap";
import Avatar from "shared/components/Avatar";
import Icon from "shared/components/Icon";

const SelectComponent = () => {
  const data = [
    { label: "Sài Gòn", value: "1" },
    { label: "Hà Nội", value: "2" },
    { label: "Kiên Giang", value: "3" },
  ];
  const [val, setVal] = useState(data);
  const selectRef = useRef<any>();
  return (
    <Container>
      <Row style={{ justifyContent: "space-evenly" }}>
        <Select data={data} label="Editable" editable />
        <Select data={data} label="Single" />
        <Select
          ref={selectRef}
          data={data}
          label="Multi"
          isMultiple
          values={val}
          onChanged={(val) => setVal(val)}
          customContent={
            <div style={{ display: "flex" }}>
              {val.map((dt) => (
                <Avatar
                  style={{ marginLeft: -5 }}
                  name={dt.label}
                  key={dt.label}
                  value={dt.value}
                  tooltip
                />
              ))}
              <Icon name="edit" onClick={() => selectRef.current?.toggle?.()} />
            </div>
          }
        />
      </Row>
    </Container>
  );
};

export default SelectComponent;
